module.exports = __webpack_public_path__ + "img/arrow-right.d532842a.svg";